import React, { ReactNode } from "react";

import "./AudienceOverlapInfoState.scss";

interface Props {
  icon: ReactNode;
  title: ReactNode;
  text: ReactNode;
  children?: ReactNode;
}

/**
 * Greyed-out outline of the platform and chart boxes, fading out towards a message below.
 * Shown instead of the audience overlap while there is nothing to display (off, calculating, failed).
 */
export default function AudienceOverlapInfoState({
  icon,
  title,
  text,
  children,
}: Props) {
  return (
    <div className="audience-overlap-info">
      <div className="audience-overlap-info__skeleton">
        <div className="audience-overlap-info__skeleton-box audience-overlap-info__skeleton-box--platform">
          <span className="audience-overlap-info__skeleton-circle" />
          <span className="audience-overlap-info__skeleton-bar" />
        </div>

        <div className="audience-overlap-info__skeleton-box audience-overlap-info__skeleton-box--chart">
          <div className="audience-overlap-info__skeleton-rows">
            <div className="audience-overlap-info__skeleton-row">
              <span className="audience-overlap-info__skeleton-square" />
              <span className="audience-overlap-info__skeleton-bar" />
            </div>
            <div className="audience-overlap-info__skeleton-row">
              <span className="audience-overlap-info__skeleton-square" />
              <span className="audience-overlap-info__skeleton-bar" />
            </div>
          </div>

          <span className="audience-overlap-info__skeleton-donut" />
        </div>
      </div>

      <div className="audience-overlap-info__info">
        {icon}
        <div className="audience-overlap-info__info-bold">{title}</div>
        <div className="audience-overlap-info__info-text">{text}</div>
        {children}
      </div>
    </div>
  );
}
